import TextField from "@mui/material/TextField";
import { useId } from "react";

const STAGES = [
  { key: "pre_seed", label: "Pre-seed" },
  { key: "with_seed", label: "At seeding" },
  { key: "post_seed", label: "Post-seed" },
];

export default function FertilizerTableField({
  fertilizerName,
  onChange,
  elementCode,
  fieldState,
}) {
  const fieldId = useId();
  const total = STAGES.reduce((sum, stage) => {
    const value = Number(fieldState?.[stage.key]);
    return sum + (Number.isFinite(value) ? value : 0);
  }, 0);

  return (
    <div className="grid min-w-[700px] grid-cols-[minmax(180px,1.2fr)_repeat(3,minmax(130px,1fr))_100px] items-center border-t border-slate-100">
      <div className="px-3 py-2.5">
        <p className="text-sm font-bold text-slate-800">{fertilizerName}</p>
        <p className="text-xs text-slate-500">{elementCode}</p>
      </div>
      {STAGES.map((stage) => {
        const value = fieldState?.[stage.key];
        const invalid =
          value !== "" &&
          value !== null &&
          value !== undefined &&
          Number(value) < 0;
        return (
          <div className="px-2 py-2" key={stage.key}>
            <TextField
              error={invalid}
              size="small"
              id={`${fieldId}-${stage.key}`}
              variant="outlined"
              type="number"
              value={fieldState?.[stage.key] ?? ""}
              onChange={(event) =>
                onChange(event.target.value, elementCode, stage.key)
              }
              inputProps={{
                min: 0,
                step: "any",
                "aria-label": `${fertilizerName} ${stage.label} rate`,
              }}
              helperText={invalid ? "Use zero or more." : ""}
              fullWidth
            />
          </div>
        );
      })}
      <div className="px-3 py-2 text-right text-sm font-bold text-slate-700">
        {total.toLocaleString(undefined, { maximumFractionDigits: 2 })}
      </div>
    </div>
  );
}
